import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/providers';
// Imported from its own module rather than the `common` barrel: the barrel also
// re-exports DatePicker, which drags react-day-picker (~80 kB) into the entry
// chunk — the opposite of what this fix is for.
import { LoadingState } from '@/components/common/LoadingState';
import { router } from '@/routes/router';

/**
 * A Suspense boundary sits above the router as the application-wide safety net.
 *
 * Every route element is `lazy()`, and a lazy component that suspends with no
 * boundary above it does not degrade gracefully — React throws (minified error
 * #426) and the entire screen is replaced by an error page. The authenticated
 * branch has its own boundary inside `AppLayout`, but the guest branch had none,
 * so the sign-in screen failed for anyone whose connection was slow enough for
 * the chunk to actually suspend. On a fast desktop link the module arrives
 * before React needs a fallback and the bug is invisible, which is exactly why
 * this has to be a boundary rather than something caught by testing locally.
 */
export const App = () => (
  <AppProviders>
    <Suspense fallback={<LoadingState variant="page" label="Loading…" />}>
      <RouterProvider router={router} />
    </Suspense>
  </AppProviders>
);

export default App;
